<template>
<div class="app has-header">
    <div class="header main">
        <div class="align-left">
            <dateselectionheader ref="datepickerfrom" :label="monthDisplay" :disableCalendar="true" :disableArrows="true" :disableToday="true" :fromToMode="1" />
            <dateselectionheader ref="datepickerto" :label="endMonthDisplay" :disableArrows="true" :disableToday="true" :fromToMode="2" @CalendarOpen="toggleDatePicker($event, 1, true)" />
        </div>
        <div class="align-middle">
            <headerbuttonstack :state="headerButtons" />
        </div>
        <div class="align-right">
            <headerbuttonstack :state="sideButtons" />
        </div>
    </div>

    <div v-show="!datePicking" class="tablecontainer scrollbar-container">
        <div style="margin-bottom: 70px;">
            <datatable :state="dataTableState" />
        </div>
    </div>
    <div v-if="loading" class="loading-md bg">
        <i class="fas fa-spinner"></i>
        <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
            {{ loadingText }}
        </div>
    </div>
    <employeeworkbalancecreation ref="employeeworkbalancecreation" ></employeeworkbalancecreation>
</div>
</template>

<script>
import datatable from '../uicomponents/datatable.vue';
import datatableslim from '../uicomponents/datatableslim.vue';
import employeeworkbalancecreation from '../workbalancecontext/EmployeeWorkBalanceCreation.vue';
import VueEventBus from '../../vue-event-bus';
import {
    mapState,
    mapGetters
} from 'vuex';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
export default {
    name: 'employeeworkbalanceoverview',
    components: {
        datatable,
        datatableslim,
        employeeworkbalancecreation
    },
    data() {
        return {
            tableHeaderStylesXSmall: {
                'font-size': '8px !important',
                'font-weight': 400
            },
            tableRowStylesXSmall: {
                fontSize: '8px',
                height: '30px',
                width: '100%',
                padding: '0 2px'
            },
            tableHeaderStylesSmall: {
                'font-size': '10px !important',
                'font-weight': 400,
            },
            tableRowStylesSmall: {
                fontSize: '9px',
                height: '35px',
                width: '100%',
                fontWeight: 300,
                padding: '0 1px'
            },
            tableHeaderStyles: {
                'font-size': '13px !important',
                'font-weight': 400
            },
            tableRowStyles: {
                fontSize: '13px',
                height: '40px',
                width: '100%',
                fontWeight: 300,
                padding: '0 4px'
            },
            datePicking: false,
            showDetails: true,
            colored: true,
            loadingText: this.$t('workBalance.payroll.loadingMonthlyData'),
            dateSelectionStart: this.$helpers.getCurrentMonthMomentTZ().hours(0).minutes(0),
            dateSelectionEnd: this.$helpers.getCurrentMonthMomentTZ().hours(0).minutes(0),
            timeFrameStart: this.$helpers.getMomentTZ().hours(0).minutes(0), //this.$helpers.getMomentTZ().date(14).hours(0).minutes(0), //changing .date here for debugging for now
            timeFrameLength: 24 * 60 * 60 * 1000,
            timeFrameEnd: this.$helpers.getMomentTZ().hours(0).minutes(0),
            currentYear: this.$helpers.getCurrentMonthMomentTZ().year(),
            currentMonth: this.$helpers.getCurrentMonthMomentTZ().month(),
            currentDate: 1,
            currentEndYear: this.$helpers.getCurrentMonthMomentTZ().year(),
            currentEndMonth: this.$helpers.getCurrentMonthMomentTZ().month(),
            currentEndDate: 1,
            employeeMap: {},
            workBalanceMap: {},
            confirmationCheckedAndPossible: false,
            employeeOptions: [],
            previousMonthWorkBalanceMap: {},
            actualShiftMap: {},
            actualBreakMap: {},
            employeePlanShiftMap: {},
            employeePreferenceMap: {},
            employeeContractMap: {},
            bonusPaymentSettingsMap: {},
            nextMonthEmployeeContractMap: {},
            employeeAvgWorktimeMap: {},
            multiCreateList: {},
            holidayMap: {},
            currentrow: {},
            balanceerror: false,
            readyFlag: false,
            creationMode: 0,

            loading: false
        }
    },
    created: function () {
        this.$helpers.GetStoreSettings();
        let date = this.$helpers.getCurrentMonthMomentTZ();
        
        this.timeFrameStart = date.clone();
        this.timeFrameEnd = date.clone().add(2, 'months');
        
        let startDate = this.timeFrameStart.clone().startOf('month');
        let endDate = this.timeFrameEnd.clone().startOf('month');
                
        this.updateDateSelection(startDate, endDate);
        if (this.$store.state.jwt != undefined && this.$store.state.storeId != undefined) {
            this.refresh(true);
        }
    },
    computed: {
        ...mapGetters(['storeId', 'storeSettings', 'spotMap', 'rosterFromTo', 'isSuperUser', 'employeeWorkbalanceMap', 'collectiveContractMap', 'allowedContractMap', 'accountingPeriodSettingsMap', 'contractExitSettingMap', 'uiDataMap']),
        exitReasonReverseIdMap() {
            let map = {};
            this.uiDataMap.exitReasons.forEach(item => {
                if(item.idL != null){
                    map[""+item.idL] = item.id;
                }    
            });
            return map;
        },
        allValid() {
            let allValid = true;
            Object.values(this.workBalanceMap).forEach((w) => {
                if (!w.valid) allValid = false;
            });
            return allValid;
        },
        
        employeeEmployeeWorkBalanceMap() {
            let map = {}
            const employeeWorkBalanceMap = this.workBalanceMap;
            Object.values(employeeWorkBalanceMap).forEach(item => {
                map[item.employeeId] = item;
            });
            return map;
        },
        numberOfOverviewMonths() {
            return Math.round(Math.abs(this.$helpers.getMomentDuration(this.currentToDate, this.currentFromDate).asMonths()))
        },
        employeeEmployeeMultiWorkBalanceMap() {
            let map = {};
            const employeeWorkBalanceMap = this.workBalanceMap;
            Object.values(employeeWorkBalanceMap).forEach(item => {
                if (!Object.keys(map).includes(item.employeeId)) {
                    map[item.employeeId] = {};
                }
                map[item.employeeId][this.$helpers.extractDateString(item.date, 'YYYY-MM-DDTHH:mm')] = item;
            });
            return map;
        },
        employeeEmployeeSumWorkBalanceMap() {
            let map = {};
            const employeeWorkBalanceMap = this.workBalanceMap;
            Object.values(employeeWorkBalanceMap).forEach(item => {
                if (map[item.employeeId] == undefined) {
                    let employee = this.employeeMap[item.employeeId];
                    if (employee != undefined) {
                        item['firstName'] = employee.firstName;
                        item['lastName'] = employee.lastName;
                    } else {
                        item['firstName'] = '';
                        item['lastName'] = '';
                    }
                    map[item.employeeId] = item;
                } else {
                    let oldMap = map[item.employeeId];
                    let newMap = {};
                    for (let x in oldMap) {
                        if (['workTimeBalance', 'holidayTimeBalance', 'vacationTimeBalance', 'multiplier'].includes(x)) {
                            // always use most recent value for those fields
                            let oldDate = this.$helpers.getMomentFromString(oldMap.date);
                            let newDate = this.$helpers.getMomentFromString(item.date);
                            if (newDate > oldDate) {
                                newMap[x] = item[x];
                            } else {
                                newMap[x] = oldMap[x];
                            }
                        } else if (['prevMonthTime'].includes(x)) {
                            // always use most oldest value for those fields
                            let oldDate = this.$helpers.getMomentFromString(oldMap.date);
                            let newDate = this.$helpers.getMomentFromString(item.date);
                            if (newDate < oldDate) {
                                newMap[x] = item[x];
                            } else {
                                newMap[x] = oldMap[x];
                            }
                        } else {
                            if (!['firstName', 'lastName', 'employeeId'].includes(x)) {
                                newMap[x] = oldMap[x] + item[x];
                            } else {
                                newMap[x] = oldMap[x];
                            }
                        }
                    }
                    map[item.employeeId] = newMap;
                }
            });
            return map;
        },
        employeePrevMonthEmployeeWorkBalanceMap() {
            let map = {}
            const employeeWorkBalanceMap = this.previousMonthWorkBalanceMap;
            Object.values(employeeWorkBalanceMap).forEach(item => {
                map[item.employeeId] = item;
            });
            return map;
        },
        preUsageStartDateMonth() {
            let usageStartDate = this.$helpers.getMomentFromStringUTC(this.storeSettings.usageStartDate);
            let from = this.currentMonthFrom;
            let usdMonth = usageStartDate.month();
            let usdYear = usageStartDate.year();
            let curMonth = from.month();
            let curYear = from.year();
            return (usdYear == curYear && curMonth == usdMonth - 1) || (curYear == usdYear - 1 && curMonth == 11 && usdMonth == 0);
        },
        isBeforeCurrentIRLMonth() {
            //determines whether the currently displayed month is before the current IRL month
            let currentSelectedDate = this.currentMonthFrom;
            let currentIRLDate = this.$helpers.getMomentTZ();
            let selMonth = currentSelectedDate.month();
            let selYear = currentSelectedDate.year();
            let selDate = currentSelectedDate.clone().endOf('month').date();
            let curMonth = currentIRLDate.month();
            let curYear = currentIRLDate.year();
            let curDay = currentIRLDate.date();

            return (selYear == curYear && selMonth == curMonth && selDate == curDay) || (selYear == curYear && selMonth < curMonth) || (selYear < curYear);
        },
        headerButtons() {
            let view = this;
            let state = {
                buttons: [
                    {
                        type: "block",
                        icon: "fa-sync-alt",
                        click: () => {
                            view.refresh(true)
                        },
                        tooltip: this.$t('global.general.refreshData')
                    },
                    {
                        classes: "recalculate-all",
                        type: "block yellow",
                        icon: "fa-calculator",
                        click: () => { view.calculateUnconfirmedWorkBalances(true, true, 1, true); },
                        show:  true,
                        tooltip: this.$t('workBalance.balances.updateClosings'),
                        helperText: this.$t('workBalance.balances.updateClosingsHelp'),
                    },
                    {
                        classes: "recalculate-all-actualshiftsonly",
                        type: "block orange",
                        icon: "fa-calculator",
                        click: () => { view.calculateUnconfirmedWorkBalances(true, true, 2, true); },
                        show:  true,
                        tooltip: this.$t('workBalance.balances.updateWithPunchTimes'),
                        helperText: this.$t('workBalance.balances.updateWithPunchTimesHelp'),
                    }
                ],
                showListIconAlways: true
            };
            state.helperLinks = [
                {
                    title: this.$t('workBalance.balances.emptyCells'),
                    helperText: this.$t('workBalance.balances.emptyCellsHelp'),
                    cancelLabel: this.$t('global.ui.understand'),
                },
                {
                    title:  this.$t('store.structure.getSupport'),
                    helperText:  this.$t('store.structure.getSupportHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15",
                    externalLabel:  this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close'),
                }
            ];
            return state;
        },
        sideButtons() {
            let view = this;

            let state = {
                buttons: []
            };
            state.buttons.push({
                type: "block",
                icon: "fa-bars",
                click: ($event) => {
                    view.OpenDisplayMenuDetails($event)
                }
            });

            return state;
        },
        burgermenuState() {
            let view = this;
            let state = {};

            state = {
                componentref: 'burgermenustate',
                groups: [

                ],
                items: []
            };
            let group1 = {
                label: this.$t('global.ui.view'),
                items: [{
                        classes: "toggle-details",
                        closeOnClick: true,
                        disabled: false,
                        icon: view.showDetails ? "fa-toggle-on" : "fa-toggle-off",
                        click: () => {
                            view.showDetails = !view.showDetails;
                            view.$forceUpdate();
                        },
                        show: true,
                        tooltip: view.showDetails ? this.$t('global.ui.showDetails') : this.$t('pages.employeeContract.showDetails'),
                        text: view.showDetails ? this.$t('global.ui.showDetails') : this.$t('pages.employeeContract.showDetails'),
                        helperText: this.$t('workBalance.balances.showDetailsHelp')
                    },
                    {
                        classes: "toggle-colored",
                        closeOnClick: true,
                        disabled: false,
                        icon: view.colored ? "fa-toggle-on" : "fa-toggle-off",
                        click: () => {
                            view.colored = !view.colored;
                            view.$forceUpdate();
                        },
                        show: true,
                        tooltip: view.colored ? this.$t('workBalance.balances.hideColors') : this.$t('workBalance.balances.showColors'),
                        text: view.colored ? this.$t('workBalance.balances.hideColors') : this.$t('workBalance.balances.showColors'),
                        helperText: this.$t('workBalance.balances.showColorsHelp')
                    },
                ]
            };
            let group2 = {
                label: this.$t('global.ui.additionalOptions'),
                items: [{
                        classes: "export-save",
                        type: "block green",
                        disabled: false,
                        icon: "fa-file-download",
                        click: () => {
                            view.generatePdfReport();
                        },
                        show: true,
                        tooltip: this.$t('workBalance.balances.downloadReport'),
                        text: this.$t('workBalance.balances.downloadReport'),
                        helperText: this.$t('workBalance.balances.downloadReportHelp')
                    },
                    {
                        classes: "export-open",
                        type: "block cyan",
                        disabled: false,
                        icon: "fa-file-export",
                        click: () => {
                            view.generatePdfReport(false);
                        },
                        show: true,
                        tooltip: this.$t('workBalance.balances.openToPrint'),
                        text: this.$t('workBalance.balances.openToPrint'),
                        helperText: this.$t('workBalance.balances.openToPrintHelp')
                    }
                ]
            }

            state.groups.push(group1);
            //state.groups.push(group2);

            return state;
        },
        dataTableState() {
            let view = this;
            let state = {};
            let hmap = {};
            let balancesSumMap = this.employeeEmployeeSumWorkBalanceMap;
            let balances = Object.values(balancesSumMap);

            let balancesMultiMap = this.employeeEmployeeMultiWorkBalanceMap;

            balances.forEach((wb) => {
                let emplId = wb.employeeId;
                balancesMultiMap[emplId]['sum'] = wb;
            });
            let balancesMultiArray = Object.values(balancesMultiMap);

            balancesMultiArray.sort(function (a, b) {
                if (a.sum.lastName < b.sum.lastName) return -1;
                if (a.sum.lastName > b.sum.lastName) return 1;
                if (a.sum.lastName == b.sum.lastName && a.sum.firstName < b.sum.firstName) return -1;
                if (a.sum.lastName == b.sum.lastName && a.sum.firstName > b.sum.firstName) return 1;
                return 0;
            });

            hmap.name = this.headerMapEntry('name', this.$t('pages.employeeData.name'), (i) => {
                return this.$helpers.truncate(i.sum.lastName + ' ' + i.sum.firstName, 17);
            }, true);

            let aButtons = [];
            let hButton = {};

            let numMonths = this.numberOfOverviewMonths;
            let monthKeys = [];
            for (let i = 0; i < numMonths; i++) {
                let d = this.timeFrameStart.clone().add(i, 'months');
                monthKeys.push(d.format('YYYY-MM-DDTHH:mm'));
            }

            if (monthKeys.length > 1 && this.showDetails) {
                for (let m = 0; m < monthKeys.length; m++) {
                    let k = monthKeys[m];
                    let col = m + 1;
                    let bgColor = this.colored ? col <= 4 ? "var(--overview-group-" + col + ")" : "var(--overview-group-4)" : null;
                    let kDate = this.$helpers.getMomentFromString(k).format('MM/YY');
                    hmap['workTimeRegular_' + k] = this.headerMapMinutesToHoursValueEntry('workTimeRegular', this.$t('workBalance.summary.target') + ' ' + kDate, false, this.$t('workBalance.payroll.workTimeTarget') + " " + kDate, bgColor, k);
                    hmap['prevMonthTime_' + k] = this.headerMapMinutesToHoursValueEntry('prevMonthTime', this.$t('workBalance.payroll.previousMonthShort') + ' ' + kDate, false, this.$t('workBalance.payroll.carryOver'), bgColor, k);
                    hmap['workTime_' + k] = this.headerMapMinutesToHoursValueEntry('workTime', this.$t('workBalance.summary.actual') + ' ' + kDate, false, this.$t('workBalance.payroll.workTimeActual') + " " + kDate, bgColor, k);
                    hmap['unproductiveWorkTime_' + k] = this.headerMapMinutesToHoursValueEntry('unproductiveWorkTime', this.$t('workBalance.payroll.up') + ' ' + kDate, false, this.$t('workBalance.payroll.upActualWorkTime') + " " + kDate, bgColor, k);
                    hmap['workTimeBalance_' + k] = this.headerMapMinutesToHoursValueEntry('workTimeBalance', this.$t('workBalance.payroll.balance') + ' ' + kDate, false, this.$t('workBalance.payroll.workTimeBalance') + " " + kDate, "var(--col-emphasize-1)", k);
                    hmap['holidayTime_' + k] = this.headerMapMinutesToHoursValueEntry('holidayTime', this.$t('workBalance.payroll.holidayShort') + ' ' + kDate, false, this.$t('workBalance.payroll.holidayWorkTime') + " " + kDate, bgColor, k);
                    hmap['holidayAdjustmentWorkTime_' + k] = this.headerMapMinutesToHoursValueEntry('holidayAdjustmentWorkTime', this.$t('workBalance.payroll.holidayCompensationShort') + ' ' + kDate, false, this.$t('workBalance.payroll.holidayCompensation') + " " + kDate, bgColor, k);
                    hmap['paidHolidayTime_' + k] = this.headerMapMinutesToHoursValueEntry('paidHolidayTime', this.$t('workBalance.payroll.holidayPaid') + ' ' + kDate, false, this.$t('workBalance.payroll.holidayHoursPaid') + " " + kDate, bgColor, k);
                    hmap['holidayTimeBalance_' + k] = this.headerMapMinutesToHoursValueEntry('holidayTimeBalance', this.$t('workBalance.payroll.holidayBalanceShort'), false, this.$t('workBalance.payroll.holidayBalance') + " " + kDate, "var(--col-emphasize-1)", k);
                }
            }

            let sumCol = this.colored ? 'var(--overview-group-sum)' : null;

            hmap.workTimeRegular = this.headerMapMinutesToHoursValueEntry('workTimeRegular', this.$t('workBalance.summary.target'), false, this.$t('workBalance.payroll.workTimeTarget'), sumCol, "sum");
            hmap.prevMonthTime = this.headerMapMinutesToHoursValueEntry('prevMonthTime', this.$t('workBalance.payroll.previousMonthShort'), false, this.$t('workBalance.payroll.carryOver'), sumCol, "sum");
            hmap.workTime = this.headerMapMinutesToHoursValueEntry('workTime', this.$t('workBalance.summary.actual'), false, this.$t('workBalance.payroll.workTimeActual'), sumCol, "sum");
            hmap.unproductiveWorkTime = this.headerMapMinutesToHoursValueEntry('unproductiveWorkTime', this.$t('workBalance.payroll.up'), false, this.$t('workBalance.payroll.upActualWorkTime'), sumCol, "sum");

            hmap.workTimeBalance = this.headerMapMinutesToHoursValueEntry('workTimeBalance', this.$t('workBalance.payroll.workTimeBalanceShort'), false, this.$t('workBalance.payroll.workTimeBalance'), "var(--col-emphasize-2)", "sum");

            hmap.holidayTime = this.headerMapMinutesToHoursValueEntry('holidayTime', this.$t('workBalance.payroll.holidayShort'), false, this.$t('workBalance.payroll.holidayWorkTime'), sumCol, "sum");
            hmap.holidayAdjustmentWorkTime = this.headerMapMinutesToHoursValueEntry('holidayAdjustmentWorkTime', this.$t('workBalance.payroll.holidayCompensationShort'), false, this.$t('workBalance.payroll.holidayCompensation'), sumCol, "sum");
            hmap.paidHolidayTime = this.headerMapMinutesToHoursValueEntry('paidHolidayTime', this.$t('workBalance.payroll.holidayPaid'), false, this.$t('workBalance.payroll.holidayHoursPaid'), sumCol, "sum");
            hmap.holidayTimeBalance = this.headerMapMinutesToHoursValueEntry('holidayTimeBalance', this.$t('workBalance.payroll.holidayBalanceShort'), false, this.$t('workBalance.payroll.holidayBalance'), "var(--col-emphasize-2)", "sum");

            state.headerMap = hmap;
            if (this.showDetails) {
                if (monthKeys.length > 1 && monthKeys.length < 4) {
                    hmap.name.width = '7%';
                    state.headerStyles = this.tableHeaderStylesSmall;
                    state.rowStyles = this.tableRowStylesSmall;
                } else if (monthKeys.length > 3) {
                    hmap.name.width = '5%';
                    state.headerStyles = this.tableHeaderStylesXSmall;
                    state.rowStyles = this.tableRowStylesXSmall;
                } else {
                    hmap.name.width = '15%';
                    state.headerStyles = this.tableHeaderStyles;
                    state.rowStyles = this.tableRowStyles;
                }
            } else {
                hmap.name.width = '15%';
                state.headerStyles = this.tableHeaderStyles;
                state.rowStyles = this.tableRowStyles;
            }

            state.data = balancesMultiArray;
            state.coloredHeader = true;
            //state.dataSum = [this.balanceSummary];

            return state;
        },
        balanceSummary() {
            let summary = {
                vacationTimeBalance: 0,
                holidayTimeBalance: 0,
                workTimeBalance: 0,
                workTimeRegular: 0,
                workTime: 0,
                unproductiveWorkTime: 0,
                holidayAdjustmentTime: 0,
                holidayTime: 0,
                vacationTime: 0,
                sickTime: 0,
                nursingVacationTime: 0,
                educationTime: 0,
                wageContinuationTime: 0,
                paidWorkTime: 0,
                paidHolidayTime: 0,
                nightWorkTime: 0,
                nightWorkCount: 0,
                overTime: 0,
                overTimeCount: 0,
                moreTime: 0,
                moreTimeCount: 0,
                prevMonthTime: 0,
                holidayAdjustmentWorkTime: 0,
                sickWorkTime: 0,
                vacationWorkTime: 0,
                educationWorkTime: 0,
                nursingVacationWorkTime: 0,
                wageContinuationWorkTime: 0,
                paidVacationTime: 0
            }
            let balances = Object.values(this.workBalanceMap);
            balances.forEach(item => {
                Object.keys(item).forEach(key => {
                    if (typeof item[key] == "number") {
                        if (!summary[key]) {
                            summary[key] = 0;
                        }
                        if (key == 'paidWorkTime') {
                            if (item[key] > 0) {
                                summary[key] += item[key];
                            }
                        } else if (key == 'paidVacationTime') {
                            if (item[key] > 0) {
                                summary[key] += item[key];
                            }
                        } else {
                            summary[key] += item[key];
                        }

                    }

                })
            });

            let sumRow = {}
            if (this.preUsageStartDateMonth) {
                sumRow.name = {
                    label: this.$t('global.ui.sum'),
                    key: 'name',
                    align: 'left'
                };
                sumRow.vacationTimeBalance = {
                    label: (summary.vacationTimeBalance / 24 / 60).toFixed(2),
                    key: 'vacationTimeBalance',
                    align: 'right'
                };
                sumRow.holidayTimeBalance = {
                    label: (summary.holidayTimeBalance / 60).toFixed(2),
                    key: 'holidayTimeBalance',
                    align: 'right'
                };
                sumRow.workTimeBalance = {
                    label: (summary.workTimeBalance / 60).toFixed(2),
                    key: 'workTimeBalance',
                    align: 'right'
                };

            } else {
                sumRow.name = {
                    label: this.$t('global.ui.sum'),
                    key: 'name',
                    align: 'left'
                };
                sumRow.vacationTimeBalance = {
                    label: (summary.vacationTimeBalance / 24 / 60).toFixed(2),
                    key: 'vacationTimeBalance',
                    align: 'right'
                };
                sumRow.holidayTimeBalance = {
                    label: (summary.holidayTimeBalance / 60).toFixed(2),
                    key: 'holidayTimeBalance',
                    align: 'right'
                };
                sumRow.workTimeBalance = {
                    label: (summary.workTimeBalance / 60).toFixed(2),
                    key: 'workTimeBalance',
                    align: 'right'
                };

                sumRow.workTimeRegular = {
                    label: (summary.workTimeRegular / 60).toFixed(2),
                    key: 'workTimeRegular',
                    align: 'right'
                };
                sumRow.workTime = {
                    label: (summary.workTime / 60).toFixed(2),
                    key: 'workTime',
                    align: 'right'
                };
                sumRow.unproductiveWorkTime = {
                    label: (summary.unproductiveWorkTime / 60).toFixed(2),
                    key: 'unproductiveWorkTime',
                    align: 'right'
                };
                sumRow.holidayAdjustmentWorkTime = {
                    label: (summary.holidayAdjustmentWorkTime / 60).toFixed(2),
                    key: 'holidayAdjustmentWorkTime',
                    align: 'right'
                };

                sumRow.holidayTime = {
                    label: (summary.holidayTime / 60).toFixed(2),
                    key: 'holidayTime',
                    align: 'right'
                };
                sumRow.paidVacationTime = {
                    label: (summary.paidVacationTime / 24 / 60).toFixed(2),
                    key: 'paidVacationTime',
                    align: 'right'
                };
                sumRow.vacationTime = {
                    label: (summary.vacationTime / 24 / 60).toFixed(2),
                    key: 'vacationTime',
                    align: 'right'
                };

                sumRow.sickTime = {
                    label: (summary.sickTime / 24 / 60).toFixed(2),
                    key: 'sickTime',
                    align: 'right'
                };
                sumRow.nursingVacationTime = {
                    label: (summary.nursingVacationTime / 24 / 60).toFixed(2),
                    key: 'nursingVacationTime',
                    align: 'right'
                };
                sumRow.educationTime = {
                    label: (summary.educationTime / 60).toFixed(2),
                    key: 'educationTime',
                    align: 'right'
                };
                sumRow.wageContinuationTime = {
                    label: (summary.wageContinuationTime / 60).toFixed(2),
                    key: 'wageContinuationTime',
                    align: 'right'
                };
                sumRow.paidWorkTime = {
                    label: (summary.paidWorkTime / 60).toFixed(2),
                    key: 'paidWorkTime',
                    align: 'right'
                };

                sumRow.paidHolidayTime = {
                    label: (summary.paidHolidayTime / 60).toFixed(2),
                    key: 'paidHolidayTime',
                    align: 'right'
                };

                sumRow.nightWorkTime = {
                    label: (summary.nightWorkTime / 60).toFixed(2),
                    key: 'nightWorkTime',
                    align: 'right'
                };
                sumRow.nightWorkCount = {
                    label: (summary.nightWorkCount).toFixed(0),
                    key: 'nightWorkCount',
                    align: 'right'
                };
                sumRow.overTime = {
                    label: (summary.overTime / 60).toFixed(2),
                    key: 'overTime',
                    align: 'right'
                };
                sumRow.overTimeCount = {
                    label: (summary.overTimeCount).toFixed(0),
                    key: 'overTimeCount',
                    align: 'right'
                };
                sumRow.moreTime = {
                    label: (summary.moreTime / 60).toFixed(2),
                    key: 'moreTime',
                    align: 'right'
                };
                sumRow.moreTimeCount = {
                    label: (summary.moreTimeCount).toFixed(0),
                    key: 'moreTimeCount',
                    align: 'right'
                };
                sumRow.prevMonthTime = {
                    label: (summary.prevMonthTime / 60).toFixed(2),
                    key: 'prevMonthTime',
                    align: 'right'
                };

            }

            return sumRow;

        },
        monthTimeRegular() {
            return Math.round(this.employeeType.weekTimeRegular * 4.325);
        },
        currentFromDate() {
            return this.timeFrameStart.clone();
        },
        currentFromDateTZ() {
            let fromTZ = this.$helpers.getMomentFromValuesTZ(this.currentFromDate.year(), this.currentFromDate.month(), 1);
            return fromTZ;
        },
        currentFromDateUTC() {
            return this.$helpers.getMomentFromValuesUTC(this.currentFromDate.year(), this.currentFromDate.month(), 1);
        },
        currentToDate() {
            return this.timeFrameEnd.clone().endOf('month');
        },
        currentToDateTZ() {
            let to = this.currentToDate.clone().add(1, 'month');
            let toTZ = this.$helpers.getMomentFromValuesTZ(to.year(), to.month(), 1);
            return toTZ;
        },
        currentMonthFrom() {
            let rFrom = new Date(this.rosterFromTo.from);
            let rTo = new Date(this.rosterFromTo.to);
            let diffTime = Math.abs(rTo - rFrom);
            let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            let diffDaysHalf = Math.abs(diffDays / 2);
            rFrom.setDate(rFrom.getDate() + diffDaysHalf);
            let from = this.$helpers.getMomentFromValuesUTC(rFrom.getFullYear(), rFrom.getMonth(), 1);
            return from;
        },
        currentMonthFromTZ() {

            let from = this.$helpers.getMomentFromValuesTZ(this.currentMonthFrom.year(), this.currentMonthFrom.month(), 1);
            return from;
        },
        currentMonthTo() {
            if (this.currentMonthFrom) {
                let to = this.currentMonthFrom.clone().add(1, 'month');
                return to;
            } else {
                return null;
            }

        },
        currentMonthToTZ() {
            if (this.currentMonthFromTZ) {
                let to = this.currentMonthFromTZ.clone().add(1, 'month');
                return to;
            } else {
                return null;
            }

        },
        monthDisplay: function () {
            if (this.timeFrameStart != null) {
                return this.timeFrameStart.format('MMM YYYY');
            } else {
                return '-';
            }
        },
        endMonthDisplay: function () {
            if (this.timeFrameEnd != null) {
                return this.timeFrameEnd.format('MMM YYYY');
            } else {
                return '-';
            }
        },
        employeeDateActualShiftMap() {
            let map = {};
            Object.values(this.actualShiftMap).forEach(entry => {
                if (!map[entry.employeeId]) {
                    map[entry.employeeId] = {};
                }
                let employeeEntry = map[entry.employeeId];
                let dateKey = this.$helpers.getMomentFromStringTZ(entry.from).format("YYYY-MM-DD");
                if (!employeeEntry[dateKey]) {
                    employeeEntry[dateKey] = [];
                }
                employeeEntry[dateKey].push(entry);
            })
            return map;
        },
        employeeDateActualShiftMarkedMap() {
            let map = {};
            Object.values(this.actualShiftMap).forEach(entry => {
                //if(!entry.endMissing){
                    if(!map[entry.employeeId]){
                        map[entry.employeeId] = {};
                    }
                    let employeeEntry = map[entry.employeeId];
                    let dateKey;
                    if(entry.planFrom){
                        dateKey = this.$helpers.getMomentFromStringTZ(entry.planFrom).format("YYYY-MM-DD");
                    } else {
                        dateKey = this.$helpers.getMomentFromStringTZ(entry.from).format("YYYY-MM-DD");
                    }
                    
                    employeeEntry[dateKey] = true;
                //}
                
                
                
            })
            return map;
        },
        actualShiftBreakMap() {
            let map = {};
            Object.values(this.actualBreakMap).filter(entry => this.actualShiftMap[entry.shiftId] != null).forEach(entry => {
                if (!map[entry.shiftId]) {
                    map[entry.shiftId] = [];
                }
                map[entry.shiftId].push(entry);
            });
            return map;
        },
        validEmployeeOptions() {
            let result = [];
            const employeeMap = this.employeeMap;
            const validEmployeeMap = this.validEmployeeMap;
            this.employeeOptions.forEach(id => {
                if (validEmployeeMap[id] && employeeMap[id]) {
                    result.push(employeeMap[id]);
                }
            });
            return result;
        },
    },
    watch: {
        rosterFromTo(newVal, oldVal) {
            if (newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined) {
                this.refresh(true);
            }
        },
        storeId(newVal, oldVal) {
            if (newVal != oldVal) {
                console.log("Changed storeId: " + newVal);
                this.refresh(true);
                this.readyFlag = false;
            }
        },
    },
    // methods that implement data logic.
    methods: {
        refresh: function (calculateInvalid = false) {
            if (this.currentFromDate && this.currentToDate && !this.loading) {
                let view = this;
                this.loading = true;
                view.$store.commit("setAllowContentSwitch", {
                    allowContentSwitch: false
                });
                let employeePayload = {ids: []};
                let tEwb = 0;
                
                this.loadActiveAtEmployees()
                .then(response => {
                    view.updateEmployees(response.data);
                    
                    for (let i = 0; i < response.data.length; i++) {
                        
                        employeePayload.ids.push(response.data[i].id);
                    }
                    tEwb = performance.now();
                    view.loadingText = this.$t('workBalance.balances.calculateWorkBalance')
                    return view.RecalculatePreviousMonthWorkbalances(employeePayload.ids);
                }).then(response => {
                        
                    let seconds = (performance.now()-tEwb) / 1000.0;
                    console.log("EWB RECALC TOOK " + seconds + " seconds.");
                    view.loadingText = ""
                    return view.loadEmployeeWorkBalances(employeePayload)
                })
                        
                .then(response => {
                    view.updateEmployeeWorkBalances(response.data);
                    view.init(true, calculateInvalid).then((result) => {
                        view.$store.commit("setAllowContentSwitch", {
                            allowContentSwitch: true
                        });
                        view.loading = false;
                        view.$forceUpdate();
                    });
                })
                
                .catch(function (error) {
                    view.loading = false;
                    view.$store.commit("setAllowContentSwitch", {
                        allowContentSwitch: true
                    });
                    console.log(error)
                });
            }
        },
        init: function (force = false, calculateInvalid = false, calculateForMZConfirm = false) {
            this.initMonthly();
            if (this.readyFlag && !force) {
                return new Promise((resolve, reject) => {
                    resolve(true);
                });
            } else {
                if (this.currentFromDate && this.currentToDate) {
                    let view = this;
                    return view.$helpers.GetUiDataMap()
                    .then(response => {
                        return view.$helpers.GetAccountingPeriodSettingsMap(force);
                    })
                    .then(response => {
                        return view.$helpers.GetContractExitSettingMap(force);
                    })
                    .then(response => {
                        return view.$helpers.GetSpotMap(force); 
                    })
                    .then(response => {
                        return view.loadBonusPaymentSettings();
                    })
                    .then(response => {
                        view.updateBonusPayments(response.data);
                        return view.loadActualShifts()
                    }).then(response => {
                            view.updateActualShifts(response.data);
                            return view.loadActualBreaks();
                        }).then(response => {
                            view.updateActualBreaks(response.data);
                            return view.loadHolidays();
                        }).then(response => {
                            view.updateHolidays(response.data);
                            return view.loadActiveAtEmployees();
                        }).then(response => {
                            let employeePayload = {
                                    ids: []
                                };
                            let employeeRemoteIds = [];
                            for (let i = 0; i < response.data.length; i++) {
                                let employee = response.data[i];
                                employeePayload.ids.push(employee.id);
                                if(employee.remoteId != null){
                                    employeeRemoteIds.push(employee.remoteId);
                                }
                            }
                            view.updateEmployees(response.data);

                            return view.loadEmployeePlanShifts().then(response => {
                                view.updateEmployeePlanShifts(response.data);
                                return view.loadEmployeePreferences(employeePayload);
                            }).then(response => {
                                view.updateEmployeePreferences(response.data);
                                return view.$helpers.GetAllowedContractMap(force);
                            }).then(response => {
                                
                                return view.$helpers.GetCollectiveContractMap(force);
                            }).then(response => {
                                return view.loadEmployeeContracts(employeePayload);
                            }).then(response => {
                                view.updateEmployeeContracts(response.data);
                                return view.loadNextMonthEmployeeContracts(employeePayload);
                            }).then(response => {
                                view.updateNextMonthEmployeeContracts(response.data);
                                return view.loadPreviousMonthEmployeeWorkBalances(employeePayload);
                            }).then(response => {
                                view.updatePreviousMonthEmployeeWorkBalances(response.data);
                                if(view.storeSettings.useAvgWorkTimeForPrefs){
                                    return view.$helpers.GetAvgEmployeeWorktimeMapForMonth(employeeRemoteIds, view.currentFromDate.year(), view.currentFromDate.month()+1);
                                } else {
                                    return new Promise((resolve, reject) => {
                                        resolve({});
                                    });
                                }
                            }).then(map => {
                                view.employeeAvgWorktimeMap = map;  
                                view.readyFlag = true;
                                return new Promise((resolve, reject) => {
                                    if (calculateForMZConfirm) {
                                        view.calculateInvalidWorkBalances(false, true, 2, false);
                                    } else if (calculateInvalid) {
                                        view.calculateInvalidWorkBalances(false);
                                    }

                                    resolve(true);
                                });
                            });
                        })
                        .catch(function (error) {
                            console.log(error);
                            return new Promise((resolve, reject) => {
                                reject("Error loading data necessary to create employeeworkbalances");
                            })
                        });
                } else {
                    return new Promise((resolve, reject) => {
                        reject("Not ready to create workbalances");
                    })
                }
            }

        },
        RecalculatePreviousMonthWorkbalances(employeeIds) {
            let yearDate = this.$helpers.getMomentFromValuesUTC(this.currentToDate.year(), this.currentToDate.month(), 1);
            return this.$refs.employeeworkbalancecreation.recalculatePastInvalid(yearDate, employeeIds);
        },
        OpenDisplayMenuDetails($event) {
            let view = this;

            this.$helpers.OpenPopup({
                type: 'burgermenu',
                componentState: this.burgermenuState,
                listStyle: true,
                noScroll: true,
                pointerDirection: 0,
                elRelative: $event.currentTarget,
                pointerOffset: -15,
            });
        },
        headerMapMinutesToHoursValueEntry(key, label, editable = false, tooltip = null, bgcolor = null, subkey = null) {
            let changeFunc = undefined;
            return this.headerMapEntry(key, label, (i) => {
                let val = (subkey && i[subkey] != undefined ? i[subkey][key] : i[key]);
                if(val != undefined) return (val / 60).toFixed(2);
                return '';
            }, false, 'right', 'right', changeFunc, tooltip, bgcolor);
        },
        headerMapEntry(key, label, mapFunc, sort = false, align = 'left', alignHeaderLabel = 'left', changeFunc, tooltip = null, bgcolor = null) {
            return {
                'key': key,
                'label': label,
                'sort': sort,
                'align': align,
                'alignHeaderLabel': alignHeaderLabel,
                bgcolor: bgcolor,
                textColor: 'var(--contrast-4)',
                tooltip: tooltip,
                DisplayLabel: mapFunc,
                OnChange: changeFunc
            };
        },
        initMonthly() {
            this.timeFrameStart = this.dateSelectionStart.clone().startOf('month');
        },
        loadActiveAtEmployees: function () {
            let url = '/api/sec/employee';
            let params = {
                storeId: this.$store.state.storeId,
                activeAtFrom: this.currentFromDate.clone().add(-1, 'month').format(),
                activeAtTo: this.currentToDate.clone().add(1, 'month').format(),
                ewbDate: this.$helpers.getMomentFromValuesUTC(this.currentFromDate.year(), this.currentFromDate.month(), 1).format()
            };

            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })

        },
        
        loadEmployeeWorkBalances: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({
                        data: []
                    });
                })
            } else {
                let view = this;
                let url = '/api/sec/employeeworkbalance/any/employee';

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$helpers.getMomentFromValuesUTC(this.currentFromDate.year(), this.currentFromDate.month(), 1).format(),
                    to: this.$helpers.getMomentFromValuesUTC(this.currentToDate.year(), this.currentToDate.month(), 2).format(),
                };

                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                })
            }

        },
        
        createMultiMonthEmployeeWorkBalance: function (convertTimeValues = true, returnPromise = false, toast = false) {
            if (this.multiCreateList.length > 0) {
                this.$helpers.logDebug('Multi create employeeworkbalance');
                this.balanceerror = false;
                let view = this;
                let url = '/api/sec/employeeworkbalance/multi';
                let params = {
                    storeId: this.$store.state.storeId
                };
                let payload = {
                    requests: []
                }
                this.multiCreateList.forEach(employeeWorkBalance => {
                    let request = {
                        employeeId: employeeWorkBalance.employeeId,
                        year: employeeWorkBalance.year,
                        month: employeeWorkBalance.month,
                        workTimeBalance: !convertTimeValues? employeeWorkBalance.workTimeBalance : Math.round(employeeWorkBalance.workTimeBalance*60),
                        vacationTimeBalance: !convertTimeValues? employeeWorkBalance.vacationTimeBalance : Math.round(employeeWorkBalance.vacationTimeBalance*24*60),
                        holidayTimeBalance: !convertTimeValues? employeeWorkBalance.holidayTimeBalance : Math.round(employeeWorkBalance.holidayTimeBalance*60),
                        workTimeRegular: !convertTimeValues? employeeWorkBalance.workTimeRegular : Math.round(employeeWorkBalance.workTimeRegular*60),
                        workTime: !convertTimeValues? employeeWorkBalance.workTime : Math.round(employeeWorkBalance.workTime*60),
                        unproductiveWorkTime: !convertTimeValues? employeeWorkBalance.unproductiveWorkTime :Math.round(employeeWorkBalance.unproductiveWorkTime*60),
                        educationTime: !convertTimeValues? employeeWorkBalance.educationTime : Math.round(employeeWorkBalance.educationTime*60),
                        vacationTime: !convertTimeValues? employeeWorkBalance.vacationTime : Math.round(employeeWorkBalance.vacationTime*24*60),
                        paidVacationTime: !convertTimeValues? employeeWorkBalance.paidVacationTime : Math.round(employeeWorkBalance.paidVacationTime*24*60),
                        nursingVacationTime: !convertTimeValues? employeeWorkBalance.nursingVacationTime : Math.round(employeeWorkBalance.nursingVacationTime*24*60),
                        holidayTime: !convertTimeValues? employeeWorkBalance.holidayTime : Math.round(employeeWorkBalance.holidayTime*60),
                        holidayAdjustmentTime: !convertTimeValues? employeeWorkBalance.holidayAdjustmentTime : Math.round(employeeWorkBalance.holidayAdjustmentTime*60),
                        sickTime: !convertTimeValues? employeeWorkBalance.sickTime : Math.round(employeeWorkBalance.sickTime*60),
                        wageContinuationTime: !convertTimeValues? employeeWorkBalance.wageContinuationTime : Math.round(employeeWorkBalance.wageContinuationTime*60),
                        miscTime: !convertTimeValues? employeeWorkBalance.miscTime : Math.round(employeeWorkBalance.miscTime*60),
                        miscWorkTime: !convertTimeValues? employeeWorkBalance.miscWorkTime : Math.round(employeeWorkBalance.miscWorkTime*60),
                        paidWorkTime: !convertTimeValues? employeeWorkBalance.paidWorkTime : Math.round(employeeWorkBalance.paidWorkTime*60),
                        paidHolidayTime: !convertTimeValues? employeeWorkBalance.paidHolidayTime : Math.round(employeeWorkBalance.paidHolidayTime*60),
                        prevMonthTime: !convertTimeValues? employeeWorkBalance.prevMonthTime : Math.round(employeeWorkBalance.prevMonthTime*60),
                        multiplier: employeeWorkBalance.multiplier,
                        accountingPeriodBalance: !convertTimeValues? employeeWorkBalance.accountingPeriodBalance : Math.round(employeeWorkBalance.accountingPeriodBalance*60),
                        comment: employeeWorkBalance.comment,
                        
                        vacationWorkTime: !convertTimeValues? employeeWorkBalance.vacationWorkTime : Math.round(employeeWorkBalance.vacationWorkTime*60),
                        nursingVacationWorkTime: !convertTimeValues? employeeWorkBalance.nursingVacationWorkTime : Math.round(employeeWorkBalance.nursingVacationWorkTime*60),
                        sickWorkTime: !convertTimeValues? employeeWorkBalance.sickWorkTime : Math.round(employeeWorkBalance.sickWorkTime*60),
                        holidayAdjustmentWorkTime: !convertTimeValues? employeeWorkBalance.holidayAdjustmentWorkTime : Math.round(employeeWorkBalance.holidayAdjustmentWorkTime*60),
                        educationWorkTime: !convertTimeValues? employeeWorkBalance.educationWorkTime : Math.round(employeeWorkBalance.educationWorkTime*60),
                        wageContinuationWorkTime: !convertTimeValues? employeeWorkBalance.wageContinuationWorkTime : Math.round(employeeWorkBalance.wageContinuationWorkTime*60),
                        
                        prevMonthNightWorkTime: !convertTimeValues? employeeWorkBalance.prevMonthNightWorkTime : Math.round(employeeWorkBalance.prevMonthNightWorkTime*60),
                        nightWorkTimeBalance: !convertTimeValues? employeeWorkBalance.nightWorkTimeBalance : Math.round(employeeWorkBalance.nightWorkTimeBalance*60),
                        paidNightWorkTime: !convertTimeValues? employeeWorkBalance.paidNightWorkTime : Math.round(employeeWorkBalance.paidNightWorkTime*60),
                        nightWorkTime: !convertTimeValues? employeeWorkBalance.nightWorkTime : Math.round(employeeWorkBalance.nightWorkTime*60),

                        prevMonthOverTime: !convertTimeValues? employeeWorkBalance.prevMonthOverTime : Math.round(employeeWorkBalance.prevMonthOverTime*60),
                        overTimeBalance: !convertTimeValues? employeeWorkBalance.overTimeBalance : Math.round(employeeWorkBalance.overTimeBalance*60),
                        paidOverTime: !convertTimeValues? employeeWorkBalance.paidOverTime : Math.round(employeeWorkBalance.paidOverTime*60),
                        overTime: !convertTimeValues? employeeWorkBalance.overTime : Math.round(employeeWorkBalance.overTime*60),

                        prevMonthMoreTime: !convertTimeValues? employeeWorkBalance.prevMonthMoreTime : Math.round(employeeWorkBalance.prevMonthMoreTime*60),
                        moreTimeBalance: !convertTimeValues? employeeWorkBalance.moreTimeBalance : Math.round(employeeWorkBalance.moreTimeBalance*60),
                        paidMoreTime: !convertTimeValues? employeeWorkBalance.paidMoreTime : Math.round(employeeWorkBalance.paidMoreTime*60),
                        moreTime: !convertTimeValues? employeeWorkBalance.moreTime : Math.round(employeeWorkBalance.moreTime*60),

                        dailyOverTime: !convertTimeValues? employeeWorkBalance.dailyOverTime : Math.round(employeeWorkBalance.dailyOverTime*60),
                        weeklyOverTime: !convertTimeValues? employeeWorkBalance.weeklyOverTime : Math.round(employeeWorkBalance.weeklyOverTime*60),
                        workDayOverTime: !convertTimeValues? employeeWorkBalance.workDayOverTime : Math.round(employeeWorkBalance.workDayOverTime*60),

                        prevMonthBonusTime: !convertTimeValues? employeeWorkBalance.prevMonthBonusTime : Math.round(employeeWorkBalance.prevMonthBonusTime*60),
                        bonusTimeBalance: !convertTimeValues? employeeWorkBalance.bonusTimeBalance : Math.round(employeeWorkBalance.bonusTimeBalance*60),
                        paidBonusTime: !convertTimeValues? employeeWorkBalance.paidBonusTime : Math.round(employeeWorkBalance.paidBonusTime*60),
                        bonusTime: !convertTimeValues? employeeWorkBalance.bonusTime : Math.round(employeeWorkBalance.bonusTime*60),

                        workTimeMod: !convertTimeValues? employeeWorkBalance.workTimeMod : Math.round(employeeWorkBalance.workTimeMod*60),
                        moreTimeMod: !convertTimeValues? employeeWorkBalance.moreTimeMod : Math.round(employeeWorkBalance.moreTimeMod*60),
                        overTimeToWorkTime: !convertTimeValues? employeeWorkBalance.overTimeToWorkTime : Math.round(employeeWorkBalance.overTimeToWorkTime*60),
                        holidayTimeToWorkTime: !convertTimeValues? employeeWorkBalance.holidayTimeToWorkTime : Math.round(employeeWorkBalance.holidayTimeToWorkTime*60),

                        nightWorkCount: employeeWorkBalance.nightWorkCount,
                        overTimeCount: employeeWorkBalance.overTimeCount,
                        moreTimeCount: employeeWorkBalance.moreTimeCount,
                        bonusTimeCount: employeeWorkBalance.bonusTimeCount,

                        holidayCount: employeeWorkBalance.holidayCount,
                        workCount: employeeWorkBalance.workCount,
                        educationCount: employeeWorkBalance.educationCount,
                        vacationCount: employeeWorkBalance.vacationCount,
                        wageContinuationCount: employeeWorkBalance.wageContinuationCount,
                        nursingVacationCount: employeeWorkBalance.nursingVacationCount,
                        miscCount: employeeWorkBalance.miscCount,
                        sickCount: employeeWorkBalance.sickCount,
                        holidayAdjustmentCount: employeeWorkBalance.holidayAdjustmentCount,

                        autoCalc: employeeWorkBalance.autoCalc,
                        autoEqualize: employeeWorkBalance.autoEqualize,
                        appliedAccountingPeriod: employeeWorkBalance.appliedAccountingPeriod,
                        valid: true,
                        confirmed: false
                    };
                    payload.requests.push(request);

                });
                /* console.log(params);
                console.log(payload); */

                if (returnPromise) {
                    return this.axios({
                        method: 'post',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    });
                } else {
                    this.axios({
                        method: 'post',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer " + this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        if (toast) {
                            view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$tc('workBalance.payroll.workBalanceUpdated', 2));
                        }
                        view.$store.commit("invalidateState", {
                            states: ['employeeWorkbalanceMapState']
                        });

                        view.refresh();

                    }).catch(function (error) {
                        view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$tc('workBalance.payroll.errorWorkBalanceUpdate', 2))
                        view.balanceerror = true;
                        console.log(error)
                    })
                }
            } else {
                // TODO: popup info nothing to create
            }

        },
        calculateUnconfirmedWorkBalances(toast = false, forced = false, creationMode = 1, erasePayment = false){
            this.calculateInvalidWorkBalances(true, true, 2, false);
        },
        calculateInvalidWorkBalances(toast = false, forced = false, creationMode = 1, erasePayment = false) {
            let exclEmplIds = [];
            let employeeIds = [];
            let employeeIdMonthsMap = {};
            Object.values(this.workBalanceMap).forEach((wb) => {
                if (!wb.confirmed && (!wb.valid || forced) && (wb.autoCalc || forced) && (!this.preUsageStartDateMonth || forced)) {
                    console.log('invalid found');
                    let emplId = wb.employeeId;
                    if (employeeIdMonthsMap[emplId] == undefined) {
                        let cur = {
                            employeeId: emplId,
                            dates: []
                        }
                        employeeIdMonthsMap[emplId] = cur;
                    }
                    employeeIdMonthsMap[emplId]['dates'].push(wb.date);
                }
                if ((wb.valid && !forced) || (!wb.autoCalc && !forced) || wb.confirmed || (this.preUsageStartDateMonth && !forced)) exclEmplIds.push(wb.employeeId);
            });
            this.$helpers.logDebug('calculateInvalidWorkBalances', employeeIdMonthsMap);
            this.doMultiMonthCreate(Object.keys(employeeIdMonthsMap), employeeIdMonthsMap, toast, creationMode, erasePayment);
        },
        doMultiMonthCreate(employeeIds, employeeIdMonthsMap, toast = false, creationMode = 1, erasePayment = false) {
            let view = this;
            //create workbalances without user supervision
            this.employeeOptions = employeeIds;
            
            this.$helpers.logSuccess('EMPL MONTH MAP SORTING');
            console.log(employeeIdMonthsMap);
            // sort employeeIdMonthsMap
            Object.values(employeeIdMonthsMap).forEach((emplMonthMap) => {
                emplMonthMap.dates.sort((d1, d2) => {
                    let m1 = view.$helpers.getMomentFromString(d1);
                    let m2 = view.$helpers.getMomentFromString(d2); 
                    if(m1 < m2) return -1;
                    if(m1 > m2) return 1;
                    return 0;
                });
            });
            console.log(employeeIdMonthsMap);

            this.init(false)
                .then(result => {
                    view.calculateMultiMonthEmployeeWorkBalance(employeeIds, employeeIdMonthsMap, creationMode, erasePayment);
                    view.createMultiMonthEmployeeWorkBalance(true, false, toast);
                }).catch(error => {
                    console.log(error);
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('workBalance.payroll.loadingWorkBalanceError'));
                })
        },
        calculateMultiMonthEmployeeWorkBalance(employeeIds, employeeIdMonthsMap, creationMode = 1, erasePayment = false) {
            let view = this;
            let multiCreateList = [];
            Object.values(this.employeeMap).filter(employee => employeeIds.includes(employee.id)).forEach(employee => {
                let map = employeeIdMonthsMap[employee.id];
                if (map != undefined) {
                    let dates = map.dates;
                    if (dates.length > 0) {
                        dates.forEach((d) => {
                            let fromUTC = this.$helpers.getMomentFromStringUTC(d);
                            let from = this.$helpers.getMomentFromValuesUTC(fromUTC.year(), fromUTC.month(), 1);
                            let fromTZ = this.$helpers.getMomentFromValuesTZ(from.year(), from.month(), 1);
                            let mapKey = from.format();
                            let to = from.clone().add(1, 'months');
                            let toTZ = fromTZ.clone().add(1, 'months');
                            
                            
                            let prevMonthBalance = this.getMonthWorkBalance(employee.id, fromTZ.clone().subtract(1, 'months'));
                            let prevMap = {};
                            prevMap[employee.id] = prevMonthBalance;
                            let accountingPeriodSettings = Object.values(this.accountingPeriodSettingsMap).filter(i => i.month == from.month());
                            let contractExitSettings = Object.values(this.contractExitSettingMap).length > 0 ? Object.values(this.contractExitSettingMap) : [];
                
                            let balance = this.$helpers.calculateEmployeeWorkBalance(employee, prevMap, 
                            this.employeeContractMap, this.nextMonthEmployeeContractMap, this.allowedContractMap, this.collectiveContractMap, 
                            this.employeePlanShiftMap, this.employeeDateActualShiftMap, this.employeeDateActualShiftMarkedMap, this.holidayMap, 
                            this.actualShiftBreakMap, this.employeePreferenceMap, this.workBalanceMap, this.spotMap, 
                            this.storeSettings, from, to, fromTZ, toTZ, creationMode, erasePayment,
                            accountingPeriodSettings, contractExitSettings, false, this.exitReasonReverseIdMap, 
                            this.bonusPaymentSettingsMap, this.employeeAvgWorktimeMap);
                            
                            Object.values(this.workBalanceMap).forEach((wb) => {
                                if(wb.employeeId == balance.employeeId && wb.date == balance.date){
                                    console.log('Updating workbalance in map');
                                    for(let x in balance) wb[x] = balance[x];
                                }
                            });
                            multiCreateList.push(balance);
                        });
                    }
                }

            });
            this.multiCreateList = multiCreateList;

        },
        getMonthWorkBalance(employeeId, date) {
            if (date.month() == this.currentFromDate.month() - 1 && date.year() == this.currentFromDate.year()) {
                return this.previousMonthWorkBalanceMap[employeeId];
            }
            let balances = this.employeeEmployeeMultiWorkBalanceMap[employeeId];
            let key = date.format('YYYY-MM-DDTHH:mm');
            if (balances[key] != undefined) return balances[key];
            return null;
        },
        loadPreviousMonthEmployeeWorkBalances: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({
                        data: []
                    });
                })
            } else {
                let view = this;
                let url = '/api/sec/employeeworkbalance/any/employee';
                let from = this.currentFromDate.clone().subtract(1, 'months').startOf('month');

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.$helpers.getMomentFromValuesUTC(from.year(), from.month(), 1).format(),
                    to: this.$helpers.getMomentFromValuesUTC(from.year(), from.month(), 2).format(),
                };

                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                })
            }

        },
        getMoment: function (str) {

            return this.$helpers.getMomentFromStringTZ(str);
        },

        loadEmployeePlanShifts: function (payload) {
            let url = '/api/sec/planshift';
            let params = {
                storeId: this.$store.state.storeId,
                from: this.currentMonthFromTZ.clone().startOf('week').subtract(1,'days').format(),
                to: this.currentMonthToTZ.clone().endOf('week').add(1,'days').startOf('day').format(),
            };

            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })

        },
        loadActualShifts: function (payload) {
            let url = '/api/sec/actualshift';
            let params = {
                storeId: this.$store.state.storeId,
                from: this.currentFromDateTZ.clone().subtract(1, 'days').format(),
                to: this.currentToDateTZ.clone().add(1, 'days').format(),
            };

            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })

        },
        loadBonusPaymentSettings: function (payload) {
            let url = '/api/sec/bonuspaymentsetting';
            let params = {
                storeId: this.$store.state.storeId,
                from: this.currentFromDateTZ.clone().subtract(1, 'days').format(),
                to: this.currentToDateTZ.clone().add(1, 'days').format(),
            };

            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })

        },
        loadActualBreaks: function (payload) {
            let url = '/api/sec/actualbreak';
            let params = {
                storeId: this.$store.state.storeId,
                from: this.currentFromDateTZ.clone().subtract(1, 'days').format(),
                to: this.currentToDateTZ.clone().add(1, 'days').format(),
            };

            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })

        },
        loadEmployeePreferences: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({
                        data: []
                    });
                })
            } else {
                let url = '/api/sec/employeepreference/any/employee';
                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.currentFromDateTZ.format(),
                    to: this.currentToDateTZ.format(),
                    approved: true
                }

                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                })
            }
        },
        loadEmployeeContracts: function (payload) {
            if (this.$helpers.isBlank(payload.ids) || payload.ids.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve({
                        data: []
                    });
                })
            } else {
                let url = '/api/sec/employeecontract/any/employee';

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.currentFromDateTZ.format(),
                    to: this.currentToDateTZ.format(),
                    overlapping: true
                };

                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer " + this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                });
            }

        },
        loadNextMonthEmployeeContracts : function(payload) {
            if(this.$helpers.isBlank(payload.ids) || payload.ids.length === 0){
                return new Promise((resolve, reject) => {
                    resolve({data:[]});
                })
            } else {
                let url = '/api/sec/employeecontract/any/employee';

                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.currentFromDateTZ.clone().add(1, 'month').format(),
                    to: this.currentToDateTZ.clone().add(1, 'month').format(),
                    overlapping: true
                };
            
                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                });
            }
                
        },
        updateNextMonthEmployeeContracts: function(data){
            let employeeContractMap = {};
            for (let i = 0; i < data.length; i++) {
                if(employeeContractMap[data[i].employeeId]){
                    let prevStart = this.$helpers.getMomentFromStringTZ(employeeContractMap[data[i].employeeId]);
                    let start = this.$helpers.getMomentFromStringTZ(data[i].from);
                    if(start < prevStart){
                        employeeContractMap[data[i].employeeId] = data[i];
                    }
                } else {
                    employeeContractMap[data[i].employeeId] = data[i];
                }
            }
            this.nextMonthEmployeeContractMap = employeeContractMap;
        },
        loadHolidays: function () {

            let url = '/api/sec/storeevent';
            let params = {
                storeId: this.$store.state.storeId,
                from: this.currentFromDateTZ.format(),
                to: this.currentToDateTZ.format(),
                holiday: true,
                active: true,
            };
            return this.axios({
                method: 'get',
                params: params,
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url
            })
        },
        updateHolidays: function (data) {

            let tholidays = {}
            for (let i = 0; i < data.length; i++) {
                let holiday = data[i];
                if(holiday.federalHoliday || holiday.bankHoliday || holiday.contractHoliday){
                    holiday.fromMoment = this.$helpers.getMomentFromStringTZ(holiday.from);
                    holiday.toMoment = this.$helpers.getMomentFromStringTZ(holiday.to);
                    tholidays[data[i].id] = holiday;
                }
                

            }

            this.holidayMap = tholidays;
        },
        updateBonusPayments: function (data) {

            let map = {}

            for (let i = 0; i < data.length; i++) {
                map[data[i].id] = data[i];
            }

            this.bonusPaymentSettingsMap = map;
        },
        updateActualShifts: function (data) {

            let actualShiftMap = {}

            for (let i = 0; i < data.length; i++) {
                actualShiftMap[data[i].id] = data[i];
            }

            this.actualShiftMap = actualShiftMap;
        },
        
        updateActualBreaks: function (data) {

            let actualBreakMap = {}

            for (let i = 0; i < data.length; i++) {
                actualBreakMap[data[i].id] = data[i];
            }

            this.actualBreakMap = actualBreakMap;
        },
        updateEmployees: function (data) {

            let employeeMap = {}

            for (let i = 0; i < data.length; i++) {
                employeeMap[data[i].id] = data[i];
            }

            this.employeeMap = employeeMap;
        },
        updateEmployeeWorkBalances: function (data) {
            let workBalanceMap = {};
            for (let i = 0; i < data.length; i++) {
                workBalanceMap[data[i].id] = data[i];
            }

            this.workBalanceMap = workBalanceMap;
        },
        updatePreviousMonthEmployeeWorkBalances: function (data) {
            let previousMonthWorkBalanceMap = {};
            for (let i = 0; i < data.length; i++) {
                previousMonthWorkBalanceMap[data[i].employeeId] = data[i];
            }
            this.previousMonthWorkBalanceMap = previousMonthWorkBalanceMap;
        },
        updateEmployeePlanShifts: function (data) {
            let employeePlanShiftMap = {};
            for (let i = 0; i < data.length; i++) {
                if (data[i].employeeId) {
                    if (!employeePlanShiftMap[data[i].employeeId]) {
                        employeePlanShiftMap[data[i].employeeId] = [];
                    }
                    employeePlanShiftMap[data[i].employeeId].push(data[i]);
                }

            }
            this.employeePlanShiftMap = employeePlanShiftMap;
        },
        updateEmployeePreferences: function (data) {
            let employeePreferenceMap = {};
            for (let i = 0; i < data.length; i++) {
                if (!employeePreferenceMap[data[i].employeeId]) {
                    employeePreferenceMap[data[i].employeeId] = [];
                }
                employeePreferenceMap[data[i].employeeId].push(data[i]);
            }
            this.employeePreferenceMap = employeePreferenceMap;
        },
        updateEmployeeContracts: function (data) {
            let employeeContractMap = {};
            for (let i = 0; i < data.length; i++) {
                if (!employeeContractMap[data[i].employeeId]) {
                    employeeContractMap[data[i].employeeId] = [];
                }
                employeeContractMap[data[i].employeeId].push(data[i]);
            }
            this.employeeContractMap = employeeContractMap;
        },
        updateDateSelection(date, endDate) {
            let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
            this.dateSelectionStart = fixedDate;

            this.currentDate = fixedDate.date();
            this.currentMonth = fixedDate.month();
            this.currentYear = fixedDate.year();

            let fixedEndDate = this.$helpers.getMomentTZ().year(endDate.year()).month(endDate.month()).date(endDate.date()).startOf('day');
            this.dateSelectionEnd = fixedEndDate;

            this.currentEndDate = fixedEndDate.date();
            this.currentEndMonth = fixedEndDate.month();
            this.currentEndYear = fixedEndDate.year();

            this.refresh(true);
            this.mzConfirmed = false;
            this.init(true);
            this.$forceUpdate();
        },
        setDateSelection(date) {
            let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
            this.dateSelectionStart = fixedDate;

            this.currentDate = fixedDate.date();
            this.currentMonth = fixedDate.month();
            this.currentYear = fixedDate.year();

            //update vuex store with calculated from to => triggers reload of data via refresh
            let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
            this.$store.commit('setRosterFromTo', {
                rosterFromTo: rosterFromTo
            });
            this.mzConfirmed = false;
            this.init(true);
            this.$forceUpdate();
        },
        toggleDatePicker($event, fromToMode = null, userTriggered = true, elem = null, initialDate = null) {
            let view = this;
            this.datePicking = true;
            let elemRelative = $event ? $event.currentTarget : elem;
            let date = initialDate? initialDate : this.$helpers.getMomentTZ().date(this.currentDate).month(this.currentMonth).year(this.currentYear);
            this.$helpers.OpenDatepickerPopup({
                viewsEnabled: ['M'],
                date: date,
                fromToMode: fromToMode,
                numberOfMonthsSelected: 3
            }, {
                OnDateSelect: (date) => {
                    view.onDatePicked(date, userTriggered, elemRelative)
                },
                Cancelled: () => {
                    view.datePicking = false;
                }
            }, {
                elRelative: elemRelative
            });
        },
        onDatePicked(date, userTriggered = true, elRelative = null) {
            let setSelection = true;
            this.datePicking = true;
            
            let beforeFrom = this.timeFrameStart.clone();
            this.timeFrameStart = date.clone();
            if (userTriggered) {
                let beforeTo = this.timeFrameEnd.clone();
                this.timeFrameEnd = date.clone().add(2, 'months')
            }
             
            if (setSelection) {
                let startDate = this.timeFrameStart.clone().startOf('month');
                let endDate = this.timeFrameEnd.clone().startOf('month');
                this.updateDateSelection(startDate, endDate);
                this.datePicking = false;
            }
        },
        switchToInvalidDate(date) {
            this.selectedInvalidBalances = [];
            this.hideModal('modal-confirmworkbalance');
            this.hideModal('modal-mzconfirm');
            this.setDateSelection(date, true);
        },
        generatePdfReport(save = true) {

            let view = this;
            let headers = [this.$t('pages.employeeData.name'), this.$t('workBalance.summary.target'), this.$t('workBalance.payroll.previousMonthShort'), this.$t('workBalance.summary.actual'), 'U. Ist', 'Krank', this.$t('workBalance.summary.sickPayShort'), this.$t('workBalance.summary.nursingLeaveShort'), this.$t('workBalance.summary.vacation'), this.$t('workBalance.payroll.modifiedVacationShort'), 'U-Rest', 'mod.', this.$t('workBalance.payroll.workTimeBalanceShort'), this.$t('workBalance.payroll.holidayShort'), this.$t('workBalance.payroll.holidayCompensationShort'), 'FT mod.', this.$t('workBalance.payroll.holidayBalanceShort')];
            let sums = [this.$t('shift.template.total'), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            let prefix = this.isBeforeCurrentIRLMonth ? "" : "Entwurf "
            let filename = prefix + 'Monatsabschluss_' + this.currentMonthFrom.format('YYYY-MM') + '.pdf';
            let body = [];
            let repDoc = this.$helpers.tableReportDoc(
                headers,
                prefix + 'Monatsabschluss ' + this.currentMonthFrom.format('MMMM YYYY'),
                this.storeSettings.name,
                this.storeSettings.description,
                this.userFullname,
                9);
            let doc = repDoc.doc;
            let contentOffsetY = repDoc.contentOffsetY;
            doc.setFontSize(12);

            let balances = Object.values(this.workBalanceMap);
            balances.sort(function (a, b) {
                let ea = view.employeeMap[a.employeeId];
                let eb = view.employeeMap[b.employeeId];
                if (ea != undefined && eb != undefined) {
                    if (ea.lastName < eb.lastName) return -1;
                    if (ea.lastName > eb.lastName) return 1;
                    if (ea.lastName == eb.lastName && ea.firstName < eb.firstName) return -1;
                    if (ea.lastName == eb.lastName && ea.firstName > eb.firstName) return 1;
                }
                return 0;
            });
            let hmap = this.dataTableState.headerMap;

            for (let i = 0; i < balances.length; i++) {
                let bal = balances[i];
                let cur = [
                    hmap.name != undefined ? hmap.name.DisplayLabel(bal) : '',
                    hmap.workTimeRegular != undefined ? hmap.workTimeRegular.DisplayLabel(bal) : 0,
                    hmap.prevMonthTime != undefined ? hmap.prevMonthTime.DisplayLabel(bal) : 0,
                    hmap.workTime != undefined ? hmap.workTime.DisplayLabel(bal) : 0,
                    hmap.unproductiveWorkTime != undefined ? hmap.unproductiveWorkTime.DisplayLabel(bal) : 0,

                    hmap.sickTime != undefined ? hmap.sickTime.DisplayLabel(bal) : 0,
                    hmap.wageContinuationTime != undefined ? hmap.wageContinuationTime.DisplayLabel(bal) : 0,
                    hmap.nursingVacationTime != undefined ? hmap.nursingVacationTime.DisplayLabel(bal) : 0,
                    hmap.vacationTime != undefined ? hmap.vacationTime.DisplayLabel(bal) : 0,
                    hmap.paidVacationTime != undefined ? hmap.paidVacationTime.DisplayLabel(bal) : 0,
                    hmap.vacationTimeBalance != undefined ? hmap.vacationTimeBalance.DisplayLabel(bal) : 0,

                    hmap.paidWorkTime != undefined ? hmap.paidWorkTime.DisplayLabel(bal) : 0,
                    hmap.workTimeBalance != undefined ? hmap.workTimeBalance.DisplayLabel(bal) : 0,

                    hmap.holidayTime != undefined ? hmap.holidayTime.DisplayLabel(bal) : 0,
                    hmap.holidayAdjustmentWorkTime != undefined ? hmap.holidayAdjustmentWorkTime.DisplayLabel(bal) : 0,
                    hmap.paidHolidayTime != undefined ? hmap.paidHolidayTime.DisplayLabel(bal) : 0,
                    hmap.holidayTimeBalance != undefined ? hmap.holidayTimeBalance.DisplayLabel(bal) : 0,

                    /*hmap.nightWorkTime != undefined? hmap.nightWorkTime.DisplayLabel(bal):0,
                    hmap.nightWorkCount != undefined? hmap.nightWorkCount.DisplayLabel(bal):0,
                    hmap.overTime != undefined? hmap.overTime.DisplayLabel(bal):0,
                    hmap.overTimeCount != undefined? hmap.overTimeCount.DisplayLabel(bal):0, */

                ];
                sums[1] += bal.workTimeRegular;
                sums[2] += bal.prevMonthTime;
                sums[3] += bal.workTime;
                sums[4] += bal.unproductiveWorkTime;

                sums[5] += bal.sickTime;
                sums[6] += bal.wageContinuationTime;
                sums[7] += bal.nursingVacationTime;
                sums[8] += bal.vacationTime;
                sums[9] += bal.paidVacationTime;
                sums[10] += bal.vacationTimeBalance;

                sums[11] += bal.paidWorkTime;
                sums[12] += bal.workTimeBalance;

                sums[13] += bal.holidayTime;
                sums[14] += bal.holidayAdjustmentWorkTime;
                sums[15] += bal.paidHolidayTime;
                sums[16] += bal.holidayTimeBalance;
                body.push(cur);
            }
            body.push(['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']);

            sums[1] /= 60;
            sums[2] /= 60;
            sums[3] /= 60;
            sums[4] /= 60;

            sums[5] /= 60 * 24;
            sums[6] /= 60 * 24;
            sums[7] /= 60 * 24;
            sums[8] /= 60 * 24;
            sums[9] /= 60 * 24;
            sums[10] /= 60 * 24;

            sums[11] /= 60;
            sums[12] /= 60;

            sums[13] /= 60;
            sums[14] /= 60;
            sums[15] /= 60;
            sums[16] /= 60;

            for (let i = 1; i < sums.length; i++) sums[i] = sums[i].toFixed(2);

            body.push(sums);

            doc.setProperties({
                title: "Export Monatsabschluss"
            });

            doc.autoTable({
                startY: contentOffsetY,
                head: [headers],
                body: body,
                headStyles: {
                    fillColor: [109, 141, 33],
                    fontSize: 7,
                },
                bodyStyles: {
                    fontSize: 7
                },
                columnStyles: {}
            });

            if (save) {
                doc.save(filename);
            } else {
                let objectURL = URL.createObjectURL(doc.output("blob"));
                window.open(objectURL, "_blank");
                //doc.output('dataurlnewwindow');
            }
        },
        hideModal(ref) {
            this.currentrow = {};
            this.$refs[ref].hide()
        },
        showModal(ref) {
            this.$refs[ref].show()
        }
    },

}
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->

<style scoped>
.tablecontainer {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 30px;
}

.has-header>.has-header>.scrollbar-container {
    height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
    top: var(--header-height);
}

.data-table {
    top: 10px;
    position: relative;
}
</style>
